import classNames from 'classnames';
import { TruncatedElementWithTooltip } from 'components/common/TruncatedElementWithTooltip/TruncatedElementWithTooltip';
import { NavigablePanelLabelProps } from './NavigablePanelLabel.types';

const NavigablePanelLabel = ({
  label,
  isNavigable,
  onNavigate,
  isDisabled = false,
  extraClassName,
}: NavigablePanelLabelProps): React.ReactElement => (
  <TruncatedElementWithTooltip<HTMLElement> tooltip={label}>
    {(ref) =>
      isNavigable ? (
        <button
          ref={ref as React.RefObject<HTMLButtonElement>}
          type="button"
          aria-label={`Navigate to ${label}`}
          onClick={onNavigate}
          className={classNames(
            'body-base truncate overflow-ellipsis text-left max-w-[170px] cursor-pointer w-full',
            extraClassName,
          )}
        >
          {label}
        </button>
      ) : (
        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={classNames(
            'body-base truncate overflow-ellipsis text-left max-w-60',
            { 'text-essential-tertiary': isDisabled },
            extraClassName,
          )}
        >
          {label}
        </div>
      )
    }
  </TruncatedElementWithTooltip>
);

export default NavigablePanelLabel;
